<template>
  <div class="w-full section-title leading-tight mb-3">
    <slot name="default"></slot>
  </div>
</template>
<script>
export default {
  name: 'TitleWrapper',
};
</script>